import { flatMap, get, find, uniq } from 'lodash';

export const getCleanFormErrors = (
  validation: any,
  flds: any,
  record: Record<string, any>,
): string[] => {
  // console.log('FIELDS', flds);
  const errors: any[] = [];
  const brokenRules = get(validation, 'brokenRules', []) as any[];
  if (brokenRules.length) {
    // const flds = flatMap(fields.map((f: any) => get(f, 'items')));
    validation?.brokenRules?.map(({ message }: { message: string }) => {
      const fldLabel = get(message?.split('"'), '[1]', '');
      if (fldLabel) {
        // @ts-ignore
        const fldRecord = find(flds, (f) => f?.label === fldLabel);
        const dataField = get(fldRecord, 'dataField', '--------------------------');
        // console.log(message, dataField, fldRecord);
        if (!get(record, `${dataField}`, false)) {
          errors.push(message);
        }
      } else {
        errors.push(message);
      }
    });
  }
  const errorsUnique = uniq(errors);
  console.log('Errors', errorsUnique);
  return errorsUnique;
};
